import { ArrowRight, Lock, EnvelopeSimple, Phone, LinkedinLogo, PaperPlaneTilt, FileArrowUp } from "@phosphor-icons/react";

const GOOGLE_FORM_URL = "https://forms.gle/okbQVbmugENQEXcR7";
const GOOGLE_FORM_EMBED_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSc2dIR3O9yRVHyMt8CbFcVbnPDMc-wX-JoN4G0AOGhcvgb_Kg/viewform?embedded=true";
const CV_MAILTO =
  "mailto:rh@mpadvisory.fr?subject=Candidature%20%E2%80%94%20Envoi%20de%20CV&body=Bonjour%2C%0A%0AVeuillez%20trouver%20mon%20CV%20ci-joint.%0A%0ANom%20%3A%0APr%C3%A9nom%20%3A%0AT%C3%A9l%C3%A9phone%20%3A%0AM%C3%A9tier%20vis%C3%A9%20(Sales%20%2F%20IT)%20%3A%0A%0AMerci%20pour%20votre%20retour.%0ABien%20cordialement%2C";

export default function ContactForm() {
  return (
    <div data-testid="contact-form-page">
      {/* HERO */}
      <section className="bg-navy-deep text-white py-20 lg:py-24 noise-overlay relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-white/15">
            <span className="eyebrow text-purple-accent">Formulaire</span>
          </div>
          <h1 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
            Contactez <span className="font-serif-italic text-purple-accent">MP Advisory</span>
          </h1>
          <p className="mt-6 text-white/75 max-w-2xl mx-auto leading-relaxed">
            Vous êtes candidat ou entreprise ? Remplissez le formulaire et nous vous
            recontacterons rapidement.
          </p>

          {/* Primary CTA — open Google Form in new tab */}
          <div className="mt-10">
            <a
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="open-form-btn"
              className="group inline-flex items-center gap-3 rounded-full bg-purple-accent hover:bg-purple-accent-hover text-white px-8 py-4 text-[15px] font-medium transition-all hover:-translate-y-0.5 shadow-purple-glow"
            >
              Remplir le formulaire
              <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </a>
            <p className="mt-4 text-[13px] text-white/55 font-serif italic">
              Le formulaire s'ouvre dans un nouvel onglet.
            </p>
          </div>
        </div>
      </section>

      {/* GOOGLE FORM IFRAME */}
      <section className="bg-navy-deep py-12 lg:py-20" data-testid="form-iframe-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-3xl p-3 sm:p-5 shadow-floating">
            <div className="rounded-2xl overflow-hidden bg-white">
              <iframe
                src={GOOGLE_FORM_EMBED_URL}
                title="Formulaire de contact MP Advisory"
                width="100%"
                height="900"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                data-testid="google-form-iframe"
                className="w-full block"
                loading="lazy"
              >
                Chargement du formulaire…
              </iframe>
            </div>
          </div>

          {/* Reassuring note */}
          <div className="mt-8 flex items-start gap-3 p-5 rounded-2xl bg-white/[0.04] border border-white/10 backdrop-blur-sm">
            <Lock size={20} weight="duotone" className="text-purple-accent shrink-0 mt-0.5" />
            <p className="text-sm text-white/75 leading-relaxed">
              Toutes les demandes sont traitées en toute confidentialité.
              Vos données ne sont jamais partagées avec des tiers.
            </p>
          </div>
        </div>
      </section>

      {/* CV BY EMAIL */}
      <section className="bg-navy-deep pb-16 lg:pb-24" data-testid="cv-email-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl bg-gradient-to-br from-white/[0.06] to-white/[0.02] border border-purple-accent/20 p-8 lg:p-10 backdrop-blur-sm flex flex-col md:flex-row md:items-center gap-8">
            <div className="shrink-0">
              <div className="w-16 h-16 rounded-2xl bg-purple-accent/15 flex items-center justify-center">
                <FileArrowUp size={32} weight="duotone" className="text-purple-accent" />
              </div>
            </div>
            <div className="flex-1">
              <p className="eyebrow text-purple-accent">Candidats</p>
              <h3 className="mt-3 font-serif text-2xl lg:text-3xl text-white leading-tight">
                Envoyez votre CV <span className="font-serif-italic text-purple-accent">directement par email</span>
              </h3>
              <p className="mt-3 text-white/70 leading-relaxed text-[15px]">
                Vous préférez envoyer votre CV par email ? Adressez-le à
                <span className="text-white font-medium"> rh@mpadvisory.fr</span>.
                Toute candidature est traitée avec discrétion.
              </p>
            </div>
            <a
              href={CV_MAILTO}
              data-testid="cv-email-btn"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-purple-accent hover:bg-purple-accent-hover text-white px-7 py-3.5 text-[14px] font-medium transition-all hover:-translate-y-0.5 shadow-purple-glow whitespace-nowrap shrink-0"
            >
              <PaperPlaneTilt size={18} weight="duotone" />
              Envoyer mon CV par email
            </a>
          </div>
        </div>
      </section>

      {/* CONTACT BLOCK */}
      <section className="bg-body-bg py-16 lg:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <p className="eyebrow text-purple-accent">Contact direct</p>
            <h2 className="mt-3 font-serif text-2xl sm:text-3xl text-navy-deep">
              Préférez un échange <span className="font-serif-italic text-purple-accent">direct</span> ?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="direct-contact-block">
            <a
              href="mailto:rh@mpadvisory.fr"
              data-testid="form-email-link"
              className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-gray-100 shadow-subtle hover:border-purple-accent transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-purple-soft flex items-center justify-center shrink-0">
                <EnvelopeSimple size={22} weight="duotone" className="text-purple-accent" />
              </div>
              <div className="min-w-0">
                <p className="eyebrow text-purple-accent">Email</p>
                <p className="font-serif text-base text-navy-deep mt-1 truncate">rh@mpadvisory.fr</p>
              </div>
            </a>
            <a
              href="tel:+33683175127"
              data-testid="form-phone-link"
              className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-gray-100 shadow-subtle hover:border-purple-accent transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-purple-soft flex items-center justify-center shrink-0">
                <Phone size={22} weight="duotone" className="text-purple-accent" />
              </div>
              <div className="min-w-0">
                <p className="eyebrow text-purple-accent">Téléphone</p>
                <p className="font-serif text-base text-navy-deep mt-1">06 83 17 51 27</p>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/in/magalie-pichon-25247a102/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="form-linkedin-link"
              className="flex items-center gap-4 p-5 rounded-2xl bg-white border border-gray-100 shadow-subtle hover:border-purple-accent transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-purple-soft flex items-center justify-center shrink-0">
                <LinkedinLogo size={22} weight="duotone" className="text-purple-accent" />
              </div>
              <div className="min-w-0">
                <p className="eyebrow text-purple-accent">LinkedIn</p>
                <p className="font-serif text-base text-navy-deep mt-1 truncate">Magalie Pichon</p>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
